const state = { drawer: true };

const getters = {};
const actions = {};

const mutations = {
  setSideMenu: state => (state.drawer = !state.drawer)
};

export default {
  state,
  getters,
  actions,
  mutations
};
